import React, { useEffect } from 'react';
import { Advertorial } from './components/Advertorial';
import { initFacebookPixel } from './utils/facebookPixel';
export function App() {
  useEffect(() => {
    // Initialize Facebook Pixel
    initFacebookPixel();
  }, []);
  return <div className="w-full bg-white" data-id="element-0">
      {/* Facebook Pixel noscript fallback */}
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=527906828002058&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>
      <Advertorial data-id="element-3" />
    </div>;
}